module.exports = __webpack_public_path__ + "assets/b9.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b9.png
// module id = 682
// module chunks = 0